// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export type StatusColor = "success" | "warning" | "danger" | "info" | "neutral";

/* Store Custom Code */
export const statusStyles = (color?: StatusColor, customColor?: string) => {
    return css`
        margin-top: 0;

        /* Bunzl removed margin */
        position: relative;

        ${({ theme }) => css`
            /* Bunzl custom code */
            color: ${customColor ?? getColor(color)};
            font-size: ${theme.design.typography.size.smaller};
            font-weight: ${theme.design.typography.weight.bold};
        `}

        ${IconWrapper} {
            ${iconScalableStyles(pxToRem(20))}
            /* Bunzl custom code */
            margin: ${pxToRem(0, 4, 0, -1)};
        }
    `;
};
